import type { JSX } from 'react';
import { usePatientEpisodeCategoryContext } from '@frontend/utils/hooks/usePatientEpisodeCategoryContext';
import { ContactsAndTasks } from '../contactsAndTasks/ContactsAndTasks';

export function PatientEpisodeCategorySupport(): JSX.Element {
    const { episodeCategory, patient } = usePatientEpisodeCategoryContext();

    return (
        <ContactsAndTasks
            episodeCategoryName={episodeCategory}
            isFlexibleCarePath={true}
            patient={patient}
        />
    );
}
